var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVinnytsiaState || _vm.targetCities)?_c(_vm.currentStep,_vm._b({tag:"component",staticClass:"section",attrs:{"id":"onSiteInspection","price":_vm.price},on:{"handleClick":_vm.orderInspection}},'component',{
    ..._vm.confirmationMessageProps,
    ..._vm.orderInspectionProps
  },false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }